export default "__VITE_ASSET__9bbb4812__"